import { useStyles } from "../context";
import {
  CoreCheckoutComponent,
  CORE_CHECKOUT_NAME,
} from "@b2bportal/core-types";

export const useCheckoutStyles = (
  componentName: keyof typeof CoreCheckoutComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_CHECKOUT_NAME, componentName, defaultStyles);
};
